import React, { useState, useEffect } from 'react';

import { ReactComponent as IconCheck } from 'images/bind/toggle-head/check.svg';
import { ReactComponent as IconCloud } from 'images/bind/toggle-head/cloud.svg';
import { ReactComponent as IconLoadingOff } from 'images/bind/toggle-head/loading-off.svg';
import { ReactComponent as IconLoadingOn } from 'images/bind/toggle-head/loading-on.svg';
import { ReactComponent as IconLockOff } from 'images/bind/toggle-head/lock-off.svg';
import { ReactComponent as IconLockOn } from 'images/bind/toggle-head/lock-on.svg';
import { ReactComponent as IconX } from 'images/bind/toggle-head/x.svg';
import { ReactComponent as IconError } from 'images/bind/toggle-head/error.svg';

import './Toggle.scss'

export const ToggleHeadIconType = {
    loading: 0,
    checkOrX: 1,
    cloudOff: 2,
    lock: 3,
    error: 4,
};

export default function Toggle({ customHeadIconType, onClick, enable, unclickable, transparent }) {
    const [delayedEnable, setDelayedEnable] = useState(enable);
    const [delayedShowCustomHead, setDelayedShowCustomHead] = useState((customHeadIconType !== undefined));

    useEffect(() => {
        setDelayedShowCustomHead((customHeadIconType !== undefined));
    }, [customHeadIconType]);

    useEffect(() => {
        setDelayedEnable(enable);
    }, [enable]);

    let customHeadOff = undefined;
    let customHeadOn = undefined;
    switch (customHeadIconType) {
        case ToggleHeadIconType.loading:
            customHeadOff = IconLoadingOff;
            customHeadOn = IconLoadingOn;
            break;
        case ToggleHeadIconType.checkOrX:
            customHeadOff = IconX;
            customHeadOn = IconCheck;
            break;
        case ToggleHeadIconType.cloudOff:
            customHeadOff = IconCloud;
            break;
        case ToggleHeadIconType.lock:
            customHeadOff = IconLockOff;
            customHeadOn = IconLockOn;
            break;
        case ToggleHeadIconType.error:
            customHeadOff = IconError;
            break;
        default:
            break;
    }

    return (
        <div onClick={unclickable ? () => { } : onClick} 
        className={"bind-cell-toggle " + (enable ? "active " : "inactive ") + (transparent ? "transparent " : "")}>
            <div className={"bind-cell-toggle-head off " + (enable ? "inactive" : "active")} />
            {
                ((delayedShowCustomHead || (customHeadIconType !== undefined)) && (customHeadOff !== undefined)) ? (
                    React.createElement(customHeadOff, {
                        style: (!delayedShowCustomHead) ? { opacity: 0 } : {},
                        className: "head-icon off " + (delayedEnable ? "inactive" : "active")
                    })
                ) : null
            }
            <div className={"bind-cell-toggle-head on " + (enable ? "active" : "inactive")} />
            {
                ((delayedShowCustomHead || (customHeadIconType !== undefined)) && (customHeadOn !== undefined)) ? (
                    React.createElement(customHeadOn, {
                        style: (!delayedShowCustomHead) ? { opacity: 0 } : {},
                        className: "head-icon on " + (delayedEnable ? "active" : "inactive")
                    })
                ) : null
            }
        </div>
    )
}